// extracted by mini-css-extract-plugin
export default {"dialog":"style_dialog__3cssE","buttonGroupPages":"style_buttonGroupPages__qh2E9","buttonsPages":"style_buttonsPages__LJD-n"};